// extracted by mini-css-extract-plugin
export default {"cardsContainer":"AddCard_cardsContainer__Mi8xd","addCardIcon":"AddCard_addCardIcon__hBY2E","largeCard":"AddCard_largeCard__+LyjV"};